import { Strike as TiptapStrike } from "@tiptap/extension-strike";

import { ActionButton } from "../../components";

export const Strike = TiptapStrike.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.toggleStrike(),
					isActive: () => editor.isActive("strike") || false,
					icon: "Strikethrough",
					shortcutKeys: ["shift", "mod", "X"],
					tooltip: t("editor.strike.tooltip")
				}
			})
		};
	}
});
